/**
 * @desc 标签管理
 * 
 * 
*/
import { axios as request } from "../../request/http";

const interfaceUrl = {
    "api_productLabelAdd": "/product/label/add", // post 添加标签
    "api_productLabelDelete": "/product/label/delete", // post 删除标签
    "api_productLabelQueryList": "/product/label/queryList", // get 查询标签
}

// initial state
const state = {
    productLabelAll: []
}

// getters
const getters = {
    getProductLabelAll: state => {
        return state.productLabelAll
    }
}

// actions
const actions = {
    productLabelAdd: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_productLabelAdd,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data)
    },
    productLabelDelete: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_productLabelDelete,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data)
    },
    getProductLabelAll: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_productLabelQueryList,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('PRODUCT_LABEL_ALL', res.data || []);
            } else {
                commit('PRODUCT_LABEL_ALL', []);
            }
        }).catch(err => {
            commit('PRODUCT_LABEL_ALL', []);
        })

    }
}


// mutations
const mutations = {
    PRODUCT_LABEL_ALL: (state, pageData) => {
        state.productLabelAll = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/label.js